import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isUserAuthenticated } from '../selectors/users';
import { useLocation } from 'react-router-dom';
import { fetchInbox } from '../actions/capweb/capwebActions';
import { fullWidthRoute } from '../utils/utils';
import { defaultClasses, layoutCommonClasses } from '../components/Layout/Layout.utils';

const useLayoutConfig = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const userLoggedIn = useSelector(isUserAuthenticated);
  const isFullWidthRoute = fullWidthRoute(pathname);

  useEffect(() => {
    if (userLoggedIn) {
      dispatch(fetchInbox());
    }
  }, [userLoggedIn]);

  return { isFullWidthRoute, layoutCommonClasses, defaultClasses };
};

export default useLayoutConfig;
